export const loadLocalesTransformer = (data: any) => data?.configuration?.locales

export const transformWordings = (wordings: any) =>
  wordings?.length
    ? wordings?.reduce(
        (a: any, word: { key: string; value: string }) => ({
          ...a,
          [word.key]: word.value,
        }),
        {}
      )
    : null
